module.exports = {"id":"187205","name":"Luis Fuentes","rating":"73","photo":"./data/images/photos/4/187205.png","club":{"name":"U.N.A.M.","logo":"./data/images/clubs/U.N.A.M..png"},"positions":["DG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LuisFuentes0.json
// module id = 2612
// module chunks = 0